import { collate } from '@craftzdog/pouchdb-collate-react-native';
import { ViewKey } from '../schema/support/DatabaseView';

export const viewKeysAreEqual = (a: ViewKey, b: ViewKey): boolean => {
  return collate(a, b) === 0;
};
